import styled, { css } from "styled-components/macro";

import { breakpoint, space, borderRadius } from "shared/styles/constants";

interface VenueHeaderContainerProps {
  hasActions?: boolean;
}

export const VenueHeaderContainer = styled.div<VenueHeaderContainerProps>`
  display: grid;
  grid-template-columns: 2fr auto; // left content - image container
  grid-template-rows: 0 auto; // no edit options, pull image container up
  column-gap: ${space.m};
  row-gap: ${space.m};

  margin-bottom: ${space.xl};

  ${({ hasActions }) =>
    hasActions &&
    css`
      grid-template-rows: ${space.l} auto; // edit options - image container
    `}

  ${breakpoint("m", "down")} {
    display: flex;
    flex-direction: column;
  }
`;

export const VenueHeaderContent = styled.div`
  grid-row: 1 / span 2;

  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: ${space.xs};
  }

  ${breakpoint("m", "down")} {
    align-items: center;
  }
`;

export const VenueHeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${breakpoint("m", "down")} {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  grid-row-start: 2;

  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-end;

  > * + * {
    margin-left: ${space.s};
  }

  ${breakpoint("m", "down")} {
    order: -2;
    justify-content: center;
  }
`;

export const DummyImageContainer = styled(ImageContainer)`
  width: 80px;
  height: 80px;
`;

export const MapContainer = styled.div`
  flex-shrink: 1;

  height: 160px;
  width: 160px;

  border-radius: ${borderRadius.l};

  ${breakpoint("l", "down")} {
    display: none;
  }
`;

export const LastUpdatesContainer = styled.div`
  grid-column: 1 / span 2;

  justify-self: end;

  ${breakpoint("m", "down")} {
    text-align: center;
  }
`;
